import { gql } from '@apollo/client'

/**
 * Update the authenticated user's own first/last name (main account owner).
 * Backend rejects userInfoUpdateProfile for the account owner; use this instead.
 * @see BIL-1887
 */
export const USER_INFO_UPDATE = gql`
  mutation UserInfoUpdate($input: UserInfoUpdateInput!) {
    userInfoUpdate(input: $input) {
      success
      userInfo {
        uid
      }
    }
  }
`

/**
 * Update a child (non-owner) profile on the account by profile UUID.
 * Used on Manage Profiles page (/manage-profiles).
 * @see BIL-1887
 */
export const USER_INFO_UPDATE_PROFILE = gql`
  mutation UserInfoUpdateProfile($input: UserInfoUpdateProfileInput!) {
    userInfoUpdateProfile(input: $input) {
      success
      userInfo {
        uid
      }
    }
  }
`
